import React from 'react';
import { Info2 } from '@dbk/ui-icons';
import Popover from '@dbk/ui-popover';
import { BasicNumber } from '@dbk/ui-numbers';
import { IntlProvider } from '@dbk/format';
import Text from '@dbk/ui-text';
import SimpleDate from '../../../../../../components/common/date';
import { ORDER_OBJECT_TYPE, NO_DATA, TEXT_SIZE } from '../constants';
import { PALETTE } from '../../../../../../constants';
import { Currency } from '../../../../../../components/common/number';
import largeText from './trade-object.styles';


const renderValue = (props) => {
  switch (props.type) {
    case ORDER_OBJECT_TYPE.CURRENCY:
      if (props.currency && props.value) {
        return (
          <Currency
            testID={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
            accessibilityLabel={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
            renderProps={(props.size === TEXT_SIZE.LARGE) ? { size: 'header3', style: { color: PALETTE.secondaryActive } } : null}
            currencyDisplay="code"
            currency={props.currency}
            value={props.value}
            currencyStyle={(props.size === TEXT_SIZE.LARGE) ? largeText : null}
          />
        )
      }
      return <Text>{NO_DATA}</Text>;

    case ORDER_OBJECT_TYPE.TEXT:
      return (
        <span testID={`text_trade_tradeObject_${props.id ? props.id : ''}_test`} accessibilityLabel={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
          className="normal primary" style={{ color: "white" }}>{props.value && props.value.length > 0 ? props.value : NO_DATA}</span>
      )

    case ORDER_OBJECT_TYPE.DATE:
      if (props.value && props.value.length > 0) {
        return (
          <SimpleDate
            value={props.value}
            testID={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
            accessibilityLabel={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
          />
        )
      }
      return <Text>{NO_DATA}</Text>;

    case ORDER_OBJECT_TYPE.NUMBER:
      if (props.value) {
        return (
          <IntlProvider locale={props.langCode}>
            <BasicNumber
              value={props.value}
              testID={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
              accessibilityLabel={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
            />
          </IntlProvider>
        )
      }
      return <Text>{NO_DATA}</Text>
    default:
      return <Text>{NO_DATA}</Text>
  }
}


const TradeObject = (props) => (
  <div className="trade-object">
    <div className='primary'>
      <span testID={`label_trade_tradeObject_${props.id ? props.id : ''}_test`} accessibilityLabel={`label_trade_tradeObject_${props.id ? props.id : ''}_test`}>
        {props.title && props.title}
      </span>
      {props.popoverText &&
        <Popover
          mode="popup"
          orientation="top"
          position={10}
          testID={`popover_trade_tradeObject_${props.id ? props.id : ''}_test`}
          accessibilityLabel={`popover_trade_tradeObject_${props.id ? props.id : ''}_test`}
          popOverClassName="trade-popover"
          content={
            <div testID={`popover_text_trade_tradeObject_${props.id ? props.id : ''}_test`} accessibilityLabel={`popover_text_trade_tradeObject_${props.id ? props.id : ''}_test`}>
              <Text secondary>{props.popoverText}</Text>
            </div>
          }
        >
          <Info2 color="#999999" />
        </Popover>
      }
    </div>
    {renderValue(props)}
  </div>
)

export default TradeObject;

